import {LogLevel} from "../app/services/logger.service";

export const environment = {
  production: false,
  minimumLogLevel: LogLevel.DEBUG,
  // baseApiUrl: 'https://api.i-logistix.de/',
  baseApiUrl: 'http://localhost/',
};
